import { useWindowDimensions, Platform } from 'react-native'

export function useResponsive() {
  const { width, height } = useWindowDimensions()

  return {
    width,
    height,
    isDesktop: Platform.OS === 'web' && width >= 1024,
    isTablet: width >= 768 && width < 1024,
    isMobile: width < 768,
  }
}
